import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  paginationWrapper: {
    display: 'flex',
    // background: '#f0f0f0',
    borderRadius: theme.app.borderRadius.sm,
    alignItems: 'start',
    flexDirection: 'column',
    gap: 15,
    padding: 16,
    '& p': {
      color: theme.palette.primary.main
    },
    '& div': {
      // marginLeft: 'auto'
      display: 'flex'
    },
    '& button': {
      color: theme.palette.primary.main,
      minWidth: 30,
      height: 32,
      marginRight: 12,
      background: '#fff',
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: 2,
      fontSize: theme.app.typography.body.fontSize,
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      '& img': {
        alignItems: 'center',
        marginLeft: '-2px'
      },

      '&[disabled]': {
        opacity: 0.3,
        pointerEvents: 'none'
      }
    },

    '& .pagination__ellipsis': {
      pointerEvents: 'none'
    },

    '& .pagination__current-button': {
      marginTop: '0px!important',
      background: theme.palette.primary.main,
      color: '#fff',
      minWidth: 26
    },

    '@media (max-width: 600px)': {
      '& div': {
        flexWrap: 'wrap',
        rowGap: 8
      }
    }
  }
}))
